import { TestProps } from './Test';

export const TestA = ({ name }: TestProps) => {
  return <p>Ciao {name} (A)</p>;
};
